module.exports = __webpack_public_path__ + "media/images/logo_minimized-7373e916.png";